import { throttle } from "./utils/throttle"

window.addEventListener('load', () => {

	const accordions = document.querySelectorAll('.accordion')

	accordions.forEach(acc => {
		const head = acc.querySelector('.accordion-head')
		const content = acc.querySelector('.accordion-content')

		if (!head || !content) {
			return
		}

		head.addEventListener('click', () => {
			if (acc.classList.contains('open')) {
				acc.classList.remove('open')
				content.style.maxHeight = 0
			} else {
				acc.classList.add('open')
				content.style.maxHeight = `${content.scrollHeight}px`
			}
		})

		acc.classList.contains('open')
			? content.style.maxHeight = `${content.scrollHeight}px`
			: content.style.maxHeight = 0
	})

	const recalculateAccHeight = throttle(() => {
		accordions.forEach(acc => {
			const content = acc.querySelector('.accordion-content')
			if (!content) {
				return
			}

			if (acc.classList.contains('open')) {
				content.style.maxHeight = `${content.scrollHeight}px`
			}
		})
	}, 100)

	if (accordions) {
		window.addEventListener('resize', recalculateAccHeight)
	}
})